import { updateProfile } from '@services/external/user.api';
import { call, takeLatest } from 'typed-redux-saga/macro';
import { actions } from '../ducks/app';

function* setLanguageSaga({ payload }: ReturnType<typeof actions.setLanguage>) {
  try {
    yield* call(updateProfile, { preferredLanguage: payload.language });
  } catch (error) {
    console.log('setLanguageSaga error', error);
  }
}

function* appSaga() {
  yield takeLatest(actions.setLanguage, setLanguageSaga);
}

export default appSaga;
